import { render } from "./page-game-list-section.vue?vue&type=template&id=5588d39c&scoped=true"
import script from "./page-game-list-section.vue?vue&type=script&lang=js"
export * from "./page-game-list-section.vue?vue&type=script&lang=js"

import "./page-game-list-section.vue?vue&type=style&index=0&id=5588d39c&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5588d39c"],['__file',"src/components/notepad/pages/page-game-list-section.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5588d39c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5588d39c', __exports__)) {
    api.reload('5588d39c', __exports__)
  }
  
  module.hot.accept("./page-game-list-section.vue?vue&type=template&id=5588d39c&scoped=true", () => {
    api.rerender('5588d39c', render)
  })

}


export default __exports__